<template>
  <b-modal
    id="admin-modal"
    :title="
      readonly
        ? 'عرض بيانات المستخدم'
        : form.id
        ? 'تحديث بيانات مسؤول الشركة'
        : 'أضافة مسؤول شركة'
    "
    shadow
    hide-footer
    :no-close-on-backdrop="true"
    @hidden="clearForm"
    size="lg"
    body-class="p-5"
  >
    <div class="px-3 py-2">
      <VForm v-slot="{ onValidate }">
        <VFileField
          v-model="form.image"
          label="الصورة الشخصيه"
          type=".jpg, .png"
          :disabled="readonly"
        ></VFileField>
        <b-row>
          <b-col>
            <VTextField
              v-model="form.name"
              label="أسم المستخدم"
              rules="required"
              :readonly="readonly"
            ></VTextField
          ></b-col>
          <b-col
            ><VTextField
              v-model="form.phone"
              label="رقم الهاتف"
              :rules="form.id ? 'required' : 'required|numeric'"
              :readonly="readonly"
              style="direction: ltr"
            ></VTextField
          ></b-col>
        </b-row>
        <b-row>
          <b-col
            ><VTextField
              v-model="form.email"
              label="البريد الألكتروني"
              rules="required"
              :readonly="readonly"
            ></VTextField
          ></b-col>
          <b-col>
            <VTextField
              v-model="form.password"
              type="password"
              label="كلمة المرور"
              :rules="form.id ? null : 'required'"
              :readonly="readonly"
            ></VTextField>
          </b-col>
        </b-row>
        <VSelectField
          v-model="form.company_id"
          label="الشركة"
          :rules="form.id ? null : 'required'"
          :items="companies"
          :disabled="readonly"
          searchable
          :loading="companiesLoading"
          @search="onSearchCompanies"
          placeholder="ابحث عن شركة..."
        ></VSelectField>
        <b-row v-if="!readonly" class="pt-4">
          <b-col>
            <b-button
              :variant="form.id ? 'success' : 'info'"
              block
              @click="onValidate(action)"
              >{{ form.id ? "تحديث" : "أضافة" }}</b-button
            >
          </b-col>
          <b-col>
            <b-button
              variant="outline-info"
              block
              @click="$bvModal.hide('admin-modal')"
              >الغاء</b-button
            >
          </b-col>
        </b-row>
      </VForm>
    </div>
  </b-modal>
</template>

<script>
import { clearObject, successAlert, errorAlert } from "@/utils/helper";

export default {
  props: { readonly: Boolean },
  data() {
    return {
      companies: [],
      companiesLoading: false,
      searchTimeout: null,
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.admin.companies.adminForm;
      },
      set(value) {
        this.$store.commit("admin/companies/SET_ADMIN", value);
      },
    },
  },
  mounted() {
    this.loadCompanies();
  },
  beforeDestroy() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  watch: {
    // Watch for changes in form to ensure the selected company is in the list
    form: {
      handler(newForm) {
        if (
          newForm.company_id &&
          newForm.company_name &&
          !this.companies.find((c) => c.value === newForm.company_id)
        ) {
          // Add the selected company to the list if not already present
          this.companies.unshift({
            value: newForm.company_id,
            text: newForm.company_name,
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async loadCompanies(searchQuery = "") {
      this.companiesLoading = true;
      try {
        const response = searchQuery
          ? await this.$store.dispatch(
              "admin/companies/searchCompanies",
              searchQuery
            )
          : await this.$store.dispatch("admin/companies/getAll");

        this.companies = response.map((item) => ({
          value: item.id,
          text: item.name,
        }));

        // If we have a selected company from the form, ensure it's in the list
        if (this.form.company_id && this.form.company_name) {
          const existingCompany = this.companies.find(
            (c) => c.value === this.form.company_id
          );
          if (!existingCompany) {
            this.companies.unshift({
              value: this.form.company_id,
              text: this.form.company_name,
            });
          }
        }
      } catch (error) {
        errorAlert("حدثت مشكلة في تحميل الشركات");
      } finally {
        this.companiesLoading = false;
      }
    },
    onSearchCompanies(searchQuery) {
      // Clear previous timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      // Debounce search requests
      this.searchTimeout = setTimeout(() => {
        // If search query is empty or very short, load all companies
        if (!searchQuery || searchQuery.trim().length < 1) {
          this.loadCompanies("");
        } else {
          this.loadCompanies(searchQuery.trim());
        }
      }, 300);
    },
    action() {
      if (!this.form.email.includes("solarCompany")) {
        errorAlert("البريد الإلكتروني يجب أن يحتوي على كلمة 'solarCompany'");
        return;
      }
      var state = this.form.id ? "updateAdmin" : "storeAdmin";
      this.$store
        .dispatch(`admin/companies/${state}`)
        .then((response) => {
          successAlert();
          this.$bvModal.hide("admin-modal");
          this.$store.commit(
            `admin/companies/${state.toUpperCase()}_ADMIN`,
            response.payload
          );
          this.$store.dispatch("admin/companies/getAdmins", { page: 1 });
        })
        .catch((error) =>
          errorAlert(
            error.response ? error.response.data.message : "حدثت مشكله"
          )
        );
    },
    clearForm() {
      this.form = clearObject(this.form);
      // Reset companies list to initial state
      this.loadCompanies();
      this.$emit("close");
    },
  },
};
</script>

<style>
td[aria-colindex="2"] {
  text-align: right;
}
td[aria-colindex="3"] {
  direction: ltr;
}
</style>
